class CurrentPage {
  constructor(private readonly _value: number = 1) {
  }

  public next(): CurrentPage {
    return new CurrentPage(this._value + 1);
  }

  public prev(): CurrentPage {
    if (this._value - 1 <= 1) {
      return new CurrentPage();
    }
    return new CurrentPage(this._value - 1);
  }

  get value() {
    return this._value;
  }
}

export default CurrentPage;
